export default __webpack_public_path__ + "static/media/jump_rope.a68fb4a3.jpg";